<template>
  <section
    v-if="props.data"
    class="announcementBanner col"
    :class="[ props.data.parentClasses, props.data.parentStyle ? props.data.parentStyle : 'defaultStyle', {'with-bg': props.data.bgImage && props.data.bannerType !== 'default'}]"
    :style="{ backgroundColor: props.data.bgColor }"
  >
    <div
      v-if="props.data.parallax && props.data.bannerType !== 'default'"
      class="bgImage"
    >
      <NuxtPicture
        preload
        :img-attrs="{class: '', alt: props.data.parallax.title ? props.data.parallax.title : props.data.title}"
        :src="props.data.parallax.web ? props.data.parallax.web : props.data.parallax.original"
        :placeholder="[100, 60, 40]"
      />
    </div>
    
    <div
      v-else-if="props.data.bgImage && props.data.bannerType !== 'default'"
      class="bgImage"
      :style="`background-image: url(${img(props.data.bgImage, {format: 'webp'})});`"
    >
    </div>

    <div class="container">
      <div class="row flex items-center">
        <div
          class="col"
          :class="props.data.flex[0]"
        >
          <div class="announcementBanner__info">
            <div
              v-if="props.data.showLogo"
              class="hero-section-logo mb-8"
            >
              <NuxtLink
                to="/"
                :title="confMain.siteDescr"
                class="left"
              >
                <img
                  :alt="confMain.siteDescr"
                  src="/img/logo-metallic.svg"
                  class="responsive-img"
                  height="64"
                  width="192"
                />
              </NuxtLink>
            </div>

            <div
              v-if="props.data.label || props.data.title || props.data.subTitle || props.data.subHeading || props.data.descr"
              class="announcementBanner__info__sub"
            >
              <div
                v-if="props.data.label"
                class="h4 titleLabel title-style"
              >
                {{ props.data.label }}
              </div>

              <h1
                v-if="props.data.title"
                class="title title-style bold text-second-800"
                :class="[ props.data.parentClasses && props.data.parentClasses.includes('lg') ? 'lg h1' : 'h2' ]"
                v-html="convertToHtml(props.data.title)"
              ></h1>

              <h2
                v-if="props.data.subHeading"
                class="h2 subTitle bold text-second-700"
              >
                {{ props.data.subHeading }}
              </h2>

              <span
                v-if="props.data.subTitle"
                class="h4 subTitle mb-0 bold text-second-700"
              >
                {{ props.data.subTitle }}
              </span>
              <div
                v-if="props.data.descr"
                class="descr check-list alt-icon"
                v-html="convertToHtml(props.data.descr)"
              ></div>
            </div>
            <div
              v-if="((props.data.link || props.data.anchor || props.data.feedbackEnable) && props.data.buttonTitle) || props.data.externalReviews.enable || props.data.clients.enable"
              class="announcementBanner__info__cta row"
            >
              <div
                v-if="(props.data.link || props.data.anchor || props.data.feedbackEnable) && props.data.buttonTitle"
                class="announcementBanner__info__cta__more col s12 m5 l7 offset-l0 xl6"
              >
                <NuxtLink
                  v-if="props.data.link && props.data.buttonTitle"
                  :to="props.data.link"
                  class="btn btn-large waves-effect waves-light"
                  :class="props.data.buttonClasses ? props.data.buttonClasses : 'orange'"
                >
                  {{ props.data.buttonTitle }}
                </NuxtLink>

                <a
                  v-else-if="props.data.anchor && props.data.buttonTitle"
                  role="button"
                  :title="props.data.buttonTitle"
                  class="btn waves-effect waves-light"
                  :class="props.data.buttonClasses ? props.data.buttonClasses : 'orange'"
                  @click="scrollTo($event, props.data.anchor)"
                >
                  {{ props.data.buttonTitle }}
                </a>

                <button
                  v-else-if="props.data.feedbackEnable && props.data.buttonTitle"
                  role="button"
                  :title="props.data.buttonTitle"
                  class="btn waves-effect waves-light"
                  :class="props.data.buttonClasses ? props.data.buttonClasses : 'orange'"
                  @click="drawerOptions.conversation = {
                    componentId: 'FormsGroupConversationsFeedback',
                    header: props.data.buttonTitle,
                    data: {
                      form: props.data,
                      redirectLink: '/page/thank-you-108'
                    },
                    buttons: false,
                    returnData: () => { }
                  }"
                >
                  {{ props.data.buttonTitle }}
                </button>
              </div>

              <template v-if="props.data.externalReviews">
                <div
                  v-if="props.data.externalReviews.enable && props.data.externalReviews.optional !== true"
                  class="announcementBanner__info__cta__reviews row col s12 m5 xl6 valign-wrapper"
                >
                  <HelpersReviews
                    :external-reviews="props.data.externalReviews.items"
                    :classes="props.data.reverse ? 'reverse' : ''"
                  />
                </div>
              </template>
            </div>
            <template v-if="props.data.clients">
              <div
                v-if="props.data.clients.enable"
                class="announcementBanner__info__clients clients"
              >
                <strong
                  v-if="props.data.clients.label"
                  class="list-label"
                >{{ props.data.clients.label }}</strong>

                <ClientOnly>
                  <HelpersOurClientsIcons
                    :key="props.data.clients.showRandom"
                    :clients-show-only="props.data.clients.items"
                    :is-review="false"
                    :dynamics="props.data.clients.showRandom"
                    :random-count="props.data.clients.randomCount"
                  />
                  <template #fallback>
                    <div class="flex space-x-2">
                      <Skeleton
                        v-for="n in 4"
                        :key="n"
                        width="100px"
                        height="60px"
                      ></Skeleton>
                    </div>
                  </template>
                </ClientOnly>
              </div>
            </template>
          </div>
        </div>

        <div
          v-if="props.data.image && props.data.image.original && (props.data.bannerType === 'default' || !props.data.bannerType)"
          class="col no-padding"
          :class="props.data.flex[1]"
        >
          <div class="announcementBanner__image">
            <NuxtPicture
              v-if="useImage({ src: props.data.image.original }).isLoading"
              preload
              class="responsive-img fakeImg"
              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/wcAAwAB/eb9C1sAAAAASUVORK5CYII="
              :img-attrs="{class: '', alt: props.data.image.title}"
              :alt="props.data.image.title"
              width="800"
              height="500"
              quality="90"
              :placeholder="[100]"
            />

            <NuxtPicture
              v-else
              preload
              class="responsive-img"
              :src="props.data.image.original"
              :img-attrs="{class: '', alt: props.data.image.title}"
              :alt="props.data.image.title"
              width="800"
              height="500"
              quality="90"
              :placeholder="[100]"
            />
          </div>
        </div>

        <div
          v-else-if="!props.data.bgImage"
          class="col flex-center"
          :class="props.data.flex[1]"
        >
          <template v-if="props.data.externalReviews">
            <div
              v-if="props.data.externalReviews.enable && props.data.externalReviews.optional"
              class="announcementBanner__optionalReviews flex-wrap justify-center space-x-4"
            >
              <HelpersReviews
                :external-reviews="props.data.externalReviews.items"
                :classes="props.data.reverse ? 'reverse optional' : 'optional'"
              />

              <ClientOnly>
                <HelpersTeam />

                <template #fallback>
                  <div class="flex space-x-2">
                    <Skeleton
                      width="200px"
                      height="60px"
                    ></Skeleton>
                  </div>
                </template>
              </ClientOnly>
            </div>
          </template>
        </div>
        <div
          v-else
          class="col no-padding flex-center"
          :class="props.data.flex[1]"
        >
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
const img = useImage()
const { confMain } = useConfig()
const { drawerOptions } = usePopups()

/**
* Props
*/
const props = defineProps({
  data: {
    type: [Object],
    default: null
  }
})
</script>

<style lang="scss" scoped>
.announcementBanner {
  color: color("primary-color", "base-4");
  &__info {
    position: relative;
    z-index: 1;
    padding: 2rem 0;

    .hero-section-logo {
      display: flex;
      width: 100%;
    }
    .title {
      margin-bottom: 1rem;
      font-size: 2rem;
      line-height: 1.4;
      @media only screen and (max-width: 992px) {
        margin: 1rem 0;
        font-size: 1.75rem;
      }
    }
    .subTitle {
      color: color("primary-color", "base-4");
    }
    .descr {
      color: color("primary-color", "base-4");
      @media only screen and (max-width: 992px) {
        display: none;
      }
    }
    &__cta {
      align-items: center;
      margin-top: 2rem;
      &__more {
        .btn {
          width: 100%;
          @media only screen and (max-width: 768px) {
            width: max-content;
            margin: 1rem auto 0 auto;
          }
        }
        @media only screen and (max-width: 992px) {
          margin-top: 1rem;
        }
      }
      &__reviews {
        &:deep(.reviewsBlock) {
          & > a {
            @media only screen and (max-width: 992px) {
              justify-content: left;
            }
          }
          @media only screen and (max-width: 992px) {
            width: 100%;
          }
          @media only screen and (max-width: 768px) {
            width: max-content;
            margin: .5rem auto 0 auto;
          }
        }
      }
    }
    &__clients {
      margin-top: 3rem;
      .list-label {
        display: block;
        margin-bottom: .5rem;
        font-size: 11px;
        line-height: 1.25;
        letter-spacing: 1px;
        text-transform: uppercase;
        opacity: .7;
      }
      @media only screen and (max-width: 992px) {
        margin-top: 2rem;
      }
    }
    &:deep(.ourClientsIcons) {
      .ourClientsIcons {
        &__item {
          min-width: auto;
          max-width: fit-content;
          &:before {
            height: auto;
            font-size: 3rem;
          }
          @media only screen and (max-width: 992px) {
            min-width: auto;
            max-width: fit-content;
          }
          &.hide-on-small-only {
            display: flex!important;
          }
        }
      }
    }
  }
  &__optionalReviews {
    width: 100%;
    max-width: 300px;
    margin: 0 auto;
    @media only screen and (max-width: 992px) {
      display: flex;
      align-items: center;
      max-width: 500px;
      padding: 1.25rem 0 0;
      .team-holder {
        width: auto;
        padding: 0 0 0;
        margin-top: 0;
      }
    }
    &:deep(.reviewsBlock) {
      & > a {
        @media only screen and (max-width: 992px) {
          justify-content: center;
        }
      }
      &.optional {
        & > a {
          justify-content: center;
        }
      }
    }
  }

  // lg
  &.lg {
    .announcementBanner {
      &__info {
        &__sub {
          .title {
            font-size: 2rem;
            line-height: 1.2;
            letter-spacing: -.5px;
            @media only screen and (min-width: 993px) {
              font-size: 4rem;
              line-height: 1;
            }
          }
        }
      }
    }
  }

  // White Text
  &.white-text {
    color: #fff;
    .subTitle,
    .descr {
      color: #fff;
    }

    &:deep(.ourClientsIcons) {
      .ourClientsIcons {
        &__item {
          color: #fff!important;
        }
      }
    }
  }

  // Secondary Style
  &.secondary {
    padding-top: 2rem;
    .announcementBanner {
      &__info {
        padding: 0;
        &__sub {
          .title {
            font-size: 2.5rem;
            line-height: 1.2;
            letter-spacing: -.5px;
            @media only screen and (max-width: 992px) {
              font-size: 2rem;
              line-height: 1.25;
              letter-spacing: -.4px;
            }
          }
          .subTitle {
            margin: 8px 0;
            margin-bottom: 1rem;
            font-size: 1.375rem;
            line-height: 1.27;
          }
          .descr {
            @media only screen and (max-width: 992px) {
              display: block;
            }
          }
          @media only screen and (max-width: 992px) {
            text-align: left;
          }
        }
      }
    }
  }

  // Default Style
  &.defaultStyle {
    @media only screen and (max-width: 992px) {
      & > .container {
        & > .row {
          flex-direction: column-reverse !important;
        }
      }
    }
    .announcementBanner {
      &__info {
        @media only screen and (max-width: 992px) {
          text-align: center;
        }
        &__sub {
          @media only screen and (max-width: 992px) {
            text-align: center;
          }
        }
        &__cta__more {
          @media only screen and (max-width: 992px) {
            margin: 0 auto;
          }
        }
      }
      &__image {
        img {
          width: 100%;
        }
        @media only screen and (max-width: 992px) {
          height: 80vw;
        }
      }
    }
    &.with-bg {
      .bgImage {
        @media only screen and (max-width: 601px) {
          display: none;
        }
      }
      @media only screen and (max-width: 900px) {
        &:after {
          content: "";
          position: absolute;
          top: 0;
          z-index: 0;
          display: block;
          width: 100%;
          height: 100%;
          background: rgb(0 0 0 / 23%);
        }
      }
    }
  }

  // Second Style
  &.secondStyle {
    .announcementBanner {
      &__info {
        padding: 0 0;
        &__sub {
          margin-bottom: 0;
          text-align: left;
        }
      }
    }

    &.with-bg {
      padding: 1.5rem 0 2rem;

      @media only screen and (max-width: 992px) {
        flex-direction: column;
        overflow: visible;
        min-height: auto;
        padding: 0;
      }

      .bgImage {
        @media only screen and (max-width: 992px) {
          position: static;
          width: 100%;
          height: 30vh;
          &:deep(img) {
            object-position: right;
          }
        }
        @media only screen and (max-width: 600px) {
          height: 25vh;
          &:deep(img) {
            object-position: 85% 0;
          }
        }
        @media only screen and (max-width: 601px) {
          display: block;
        }
      }
      .announcementBanner {
        &__info {
          .descr {
            @media only screen and (max-width: 992px) {
              display: block;
            }
          }
        }
      }
      .container {
        @media only screen and (max-width: 992px) {
          display: flex;
          width: 90vw;
          min-width: unset;
          padding: 3rem 3rem 2rem 3rem;
          margin-top: 2rem;
          background: rgba(255,255,255,.9);
          border: 1px solid rgba(19,19,19,.5);
        }
        @media only screen and (max-width: 600px) {
          width: 90vw;
        }
      }
    }
  }

  // Second Style
  &.secondStyle_2 {
    &.with-bg {
      @media only screen and (max-width: 600px) {
        flex-direction: column;
      }

      @media only screen and (min-width: 1980px) {
        height: 500px;
      }

      .bgImage {
        &:deep(img) {
          width: 100%;
          height: 100%;

          object-fit: cover;
          object-position: center;
          @media only screen and (max-width: 600px) {
            height: 25vh;

            object-position: 85%;
          }
        }
        @media only screen and (max-width: 600px) {
          position: static;
          height: 25vh;
          background-position-x: 85%;
        }
      }
    }

    .announcementBanner {
      &__info {
        @media only screen and (max-width: 600px) {
          padding: 1rem 0;
          .title {
            margin-top: 0;
          }
        }

        .descr {
          &.check-list {
            &:deep(.list) {
              padding-left: 0;
              li {
                display: flex;
                align-items: baseline;
                margin-bottom: 0;
                font-size: 1.125rem;
                font-weight: 400;
                vertical-align: middle;
                &:before {
                  top: inherit;
                }
              }
            }
          }
        }
      }
    }
  }

  // With bg
  &.with-bg {
    position: relative;
    display: flex;
    align-items: center;
    overflow: hidden;
    min-height: 320px;

    @media only screen and (min-width: 1441px) {
      min-height: 320px;
    }
    @media only screen and (max-width: 600px) {
      min-height: 240px;
    }

    .bgImage {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      height: 100%;
      background-repeat: repeat-x;
      background-position-y: bottom;
      background-size: cover;
      @media only screen and (min-width: 993px) {
        background-position-x: center;
      }
      @media only screen and (max-width: 992px) {
        width: 100%;
        background-position-x: 0;
      }
    }

    .announcementBanner {
      &__info {
        @media only screen and (min-width: 1441px) {
          padding: 2rem;
        }
      }
    }

    &:not(.sm) {
      .title {
        margin: 2rem 0;
        font-size: 4rem;
        font-weight: 600;
        @media only screen and (min-width: 601px) {
          font-size: 3rem;
        }
        @media only screen and (min-width: 993px) {
          margin: 0;
          font-size: 4rem;
        }
        @media only screen and (max-width: 600px) {
          margin-bottom: 22px;
          font-size: 34px;
        }
        @media only screen and (max-width: 480px) {
          font-size: 2rem;
        }
      }

      @media only screen and (min-width: 601px) {
        min-height: auto;
        padding: 4rem 0 2rem;
      }

      @media only screen and (min-width: 993px) {
        min-height: 640px;
        padding: 75px 0 55px;
      }
    }
  }

  // Form
  &:deep(form) {
    .input-holder {
      @media only screen and (min-width: 601px) {
        padding: 0 11px !important;
        margin: 0 auto;
      }
      @media only screen and (max-width: 768px) {
        margin-bottom: 1.5rem;
      }

      input[type="text"],
      input[type="email"] {
        @media only screen and (min-width: 601px) {
          background-color: rgba(255,255,255,.25) !important;
          border-color: #fff !important;
        }
        @media only screen and (max-width: 992px) {
          border-color: #131313 !important;
        }
        &.invalid {
          border-color: color("red", "base") !important;
        }
      }
    }
    .btn-holder {
      @media only screen and (min-width: 601px) {
        padding: 0 11px !important;
      }
      button {
        min-width: 100% !important;
      }
    }
  }

  &:deep(.fakeImg) {
    img {
      position: relative;
      width: 100%;
      height: 100%;
    }
  }
}
</style>
